import type { CanvasChatMessage } from './canvas-types';

type ReviewMessage = Pick<CanvasChatMessage, 'role' | 'agentTaskGroups'>;
export function shouldShowAdReviewGuidance(imageCount: number, isWorking: boolean, messages: ReviewMessage[]): boolean {
  if (imageCount === 0 || isWorking) return false;
  const latest = [...messages].reverse().find(message => message.role === 'assistant');
  const cloneGroups = latest?.agentTaskGroups?.filter(group =>
    group.steps.some(step => step.toolName === 'clone_study')) ?? [];
  // Source images remain on Canvas even when every requested clone fails.
  if (cloneGroups.length && cloneGroups.every(group => group.status === 'failed')) {
    return cloneGroups.some(group => group.steps.some(step =>
      step.toolName.startsWith('clone_') && step.toolName !== 'clone_study' && step.status === 'success'));
  }
  return true;
}
